export default class BadResponseError extends Error {
  status: number
  message: string

  constructor(status: number, message?: string) {
    super(message)
    Object.setPrototypeOf(this, BadResponseError.prototype)
    this.status = status

    if (message === undefined) message = "Bad response"
    this.message = message
  }
}